import { gql } from "@apollo/client";

export const UPDATE_VEHICLE_GROUP = gql`
  mutation updateVehicleGroup($vehicleGroup: UpdateVehicleGroupInput!) {
    updateVehicleGroup(vehicleGroup: $vehicleGroup) {
      id
      name
      criteria {
        type
        values
      }
      images{
        idx
        url
        default
      }
      vehicles {
        id
        bodyType
        make
        model
        year
        licencePlate
        transmission
        colour
        steering
        fuelType
        features
        wheelPlan
        cylinderCapacity
        numberOfSeats
        numberOfDoors
      }
      deposit
      excess
      protectionPlans {
        plan {
          id
          name
          excess
          description
        }
        recurringRate {
          rateTypeName
          rateTypeDuration
          rate
          longTerm
        }
        taxable
        tax {
          title
          type
          value
        }
        
      }
      basePrices {
        rateTypeName
        rateTypeDuration
        rate
        longTerm
        mileageLimit
        pricePerExtraMile
      }
      isActivated
      hideInB2b2c
      yieldPricingEnabled
      yieldPriceSlabs {
        yieldThreshold
        rules {
          rateType
          value
          valueType
        }
        startDate
        endDate
      }
      acrissCode
      code
    }
  }
`;
